<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="title"><a id="page_i"></a>Reaching through Resistance</h1>
<p class="imagel"><img alt="Images" height="1" src="images/linet.jpg" width="422"/></p>
<p class="subtitle"><strong>Advanced Psychotherapy Techniques</strong></p>
<p class="author">Allan Abbass, MD</p>
<p class="pub"><img alt="Images" height="17" src="images/pub.jpg" width="186"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?1c4500f9